import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Textarea = props => {
  const classes = classNames({
    'form-field': true,
    'has-error': props.hasError,
    'has-label': props.label,
    [props.theme]: true
  })

  const textareaClasses = classNames({
    'form-textarea': true,
    'is-filled': props.value
  })

  return (
    <div className={classes}>
      <textarea
        id={props.id}
        className={textareaClasses}
        defaultValue={props.defaultValue}
        value={props.value}
        onSubmit={props.onBlur}
        onChange={props.onChange}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        placeholder={props.placeholder}
        disabled={props.disabled ? 'disabled' : ''}
      />
      {props.label && (
        <label className='form-label' htmlFor={props.id}>
          {props.label}
        </label>
      )}
      {props.helperText && (
        <span className='helper-text'>{props.helperText}</span>
      )}
      {props.hasError &&
        props.errorText && (
          <span className='error-text'>{props.errorText}</span>
        )}
    </div>
  )
}

Textarea.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  helperText: PropTypes.string,
  errorText: PropTypes.string,
  theme: PropTypes.oneOf(['light-theme', 'dark-theme'])
}

export default Textarea



// WEBPACK FOOTER //
// ./src/ui/forms/textarea.js